import { useEffect, useState, useMemo } from "react";
import Modal from "src/components/common/modal";
import { truckInventoryList } from "src/components/common/truckInventoryList";
import { useMyStore } from "src/components/main/mainStore";
import { myAxios, MyDate, MyFormData } from "src/components/common/functions";

const sortQTYZeroLast = arr => arr.reduce((acc, ele) => ele.qty !== 0?[ele, ...acc]:[...acc, ele], []);
//--------------------------------------------------------------------------------------------
export default function VehicleForm({
    preOrPost, 
    closeIt, 
    setWorkLogs,
    /*---- workLog ------------------------------------------------*/
    category, workLogHashKey, userName, 
    driverStr, truckNumberStr, truckStr, 
    /*-------------------------------------------------------------*/
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const list = useMemo(() => category === "GPR Concrete Scanning and Coring Project"?[]:[
        <><strong>Cleanliness/Damage/Missing items</strong> (Interior/Exterior):</>, 
        <><strong>Unusual Noise or Occurrence</strong> (During Operation):</>, 
        <><strong>Leaks/Fluid Levels</strong> (Visually Check for any leaks/check): oil/coolant/hydraulic/brake/windshield wiper fluid…pop hood, look under vehicle:</>, 
        <><strong>Batteries</strong> (Damage/cleanliness/security):</>, 
        <><strong>Instrument Gauges</strong> (fuel/hydraulic/battery)</>, 
        <><strong>*Oil sight glasses for Hydrovac Vehicles in proper operating range on water pump & blower*</strong></>, 
        <><strong>Safety Devices</strong> (beacon lights/horn/warning devices/sirens/mirrors/seat belts):</>, 
        <><strong>Safety Equipment</strong> (Fire extinguisher/ eyewash/hazard triangle, vehicle jack and accessories):</>, 
        <><strong>Windshield</strong> (condition/wipers):</>, 
        <><strong>Air Conditioning/Heater</strong> (functioning):</>, 
        <><strong>Radio</strong> (functioning):</>, 
        <><strong>Lights/Brights/Brake lights</strong> (Proper operation):</>, 
        <><strong>Tires</strong> (proper inflation/damage/tread wear): <strong>*notify if below 1.6 mm*</strong></>, 
        <><strong>Wheel Chocks</strong> (verify that the vehicle you are driving has a pair of serviceable chocks prior to departure)</>
    ], [category]);
    const [isDriver, setIsDriver] = useState(driverStr);
    const [truckNumbers, setTruckNumbers] = useState([]);
    const [curTruckNumber, setTruckNumber] = useState(truckNumberStr ?? "");
    const [inventory, setInventory] = useState(
        truckStr?(
            JSON.parse(truckStr).checkList?
            JSON.parse(truckStr):
            {
                ...JSON.parse(truckStr), 
                checkList: Array(list.length).fill(false)
            }
        )
        :
        {truckNumber: "", content: [], checkList: Array(list.length).fill(false)}
    );
    const base = inventory.content.filter(item => item.qty).length;
    //--------------------------------------------------------------------------------------------
    const handleFormSubmit = async e => {
        e.preventDefault();
        if(isDriver === "Yes" && inventory.checkList.some(v => v === false)){
            window.alert("Please submit a vehicle damage report after submit this form.");
        }
        const formData = new MyFormData(e.currentTarget);
        formData.append("preOrPost", preOrPost);
        formData.append("workLogHashKey", workLogHashKey);
        formData.append("truck", 
        isDriver?
        JSON.stringify({
            ...inventory,
            submitTime: (new MyDate()).ss(),
            submitDate: (new MyDate()).s()
        }):"");
        formData.append("submitTime", (new MyDate()).ss());
        //---------------------------------------------------
        setShowLoader(true);
        const vehicleFormRes = await myAxios("workLogs/vehicleForm.php", formData);
        setShowLoader(false);
        if(!vehicleFormRes) return;
        //---------------------------------------------------
        setWorkLogs(workLogs => workLogs.map(w => ({
            ...w, [preOrPost + "Driver"]:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data.isDriver:
                w[preOrPost + "Driver"]
            ), [preOrPost + "DriverSubmitTime"]:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data.submitTime:
                w[preOrPost + "DriverSubmitTime"]
            ), [preOrPost + "TruckNumber"]:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data.truckNumber:
                w[preOrPost + "TruckNumber"]
            ), [preOrPost + "Truck"]:(
                w.workLogHashKey === workLogHashKey?
                vehicleFormRes.data.truck:
                w[preOrPost + "Truck"]
            ), [preOrPost + "ForeignKey"]:(
                w.workLogHashKey === workLogHashKey?
                formData.get("foreignKey"):
                w[preOrPost + "ForeignKey"]
            )
        })));
        closeIt();
    }
    useEffect(() => {
        let isMounted = true;
        const getData = async() => {
            //---------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("common/readTruckNumbersOnly.php");
            if(!isMounted) return;
            setShowLoader(false);
            if(!res) return;
            //---------------------------------------------------
            setTruckNumbers(res.data);
        }
        getData();
        return () => {isMounted = false;}
    }, []);
    useEffect(() => {
        if(truckStr && JSON.parse(truckStr).truckNumber === curTruckNumber){
            if(JSON.parse(truckStr).checkList){
                setInventory(JSON.parse(truckStr));
            }else{
                setInventory({
                    ...JSON.parse(truckStr),
                    checkList: Array(list.length).fill(false)
                });
            }
        }else{
            setInventory({
                truckNumber: curTruckNumber,
                content: sortQTYZeroLast(truckInventoryList[curTruckNumber] || []),
                checkList: Array(list.length).fill(false)
            });
        }
    },[preOrPost, truckStr, curTruckNumber, list]);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = "VEHICLE INSPECTION FORM"
            width = {800}
            maxWidth = {"100%"}
            handleFormSubmit = {handleFormSubmit}
            actionKey = "Submit"
        >
            {truckStr?<div className = "my-2">submitted on {JSON.parse(truckStr).submitDate} {JSON.parse(truckStr).submitTime}</div>:<></>}
            <div className = "blk5 my-2" style = {{display: "flex"}}>
                <div className = "font-weight-bold mr-3">Are you the {preOrPost}-work driver?</div>
                <label
                    className = "mr-2"
                    htmlFor = {`isDriverYes`}
                >
                    Yes
                </label>
                <input
                    type = "radio"
                    required = {true}
                    id = {`isDriverYes`}
                    name = {`isDriver`}
                    checked = {isDriver === "Yes"}
                    value = "Yes"
                    onChange = {e => {
                        setIsDriver(e.currentTarget.value);
                    }}
                    className = "mr-3"
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
                <label
                    className = "mr-2"
                    htmlFor = {`isDriverNo`}
                >
                    No
                </label>
                <input
                    type = "radio"
                    required = {true}
                    id = {`isDriverNo`}
                    name = {`isDriver`}
                    checked = {isDriver === "No"}
                    value = "No"
                    onChange = {e => {
                        setIsDriver(e.currentTarget.value);
                    }}
                    className = ""
                    style = {{
                        width: 28, 
                        height: 28, 
                        verticalAlign: "middle", 
                        flexShrink: 0
                    }}
                />
            </div>
            {isDriver === "Yes"?<>
            <div>                
                <div className = "blk5 mb-2" style = {{display: "flex"}}>
                    <label
                        htmlFor = {`truckNumber`}
                        className = "font-weight-bold mr-2"
                    >
                        Truck Number
                    </label>
                    <select
                        className = "form-control mr-3"
                        required
                        id = {`truckNumber`}
                        name = "truckNumber"
                        value = {curTruckNumber}
                        onChange = {e => setTruckNumber(e.currentTarget.value)}
                    >
                        <option value = "">Select</option>
                        {truckNumbers.map((truckNumber, truckNumberIndex) => 
                        <option
                            key = {truckNumberIndex}
                            value = {truckNumber}
                        >
                            {truckNumber}
                        </option>
                        )}
                        <option>rental</option>
                    </select>
                </div>
                {inventory.content.length?
                <div>
                    <div className = "h4 mt-3 mb-2">Inventory Count:</div>
                    {inventory.content.slice(0, base).map((item, itemIndex) =>
                    <li key = {itemIndex} className = "mb-2">
                        <label className = "mr-2 inline" htmlFor = {"inventory item " + itemIndex}>
                            <span>{item.title}</span>
                            <span className = "ml-2 text-info">{item.qty}</span>
                        </label>
                        <input
                            type = "number"
                            required
                            step = {1}
                            //max = {item.qty}
                            min = {0}
                            style = {{maxWidth: 100}}
                            className = "form-control inline mr-2"
                            id = {"inventory item " + itemIndex}
                            value = {inventory.content[itemIndex].value || ""}
                            onKeyDown = {(e) => ['e','.'].includes(e.key) && e.preventDefault()}
                            onBlur = {e => {
                                let value = e.currentTarget.value;
                                while(value.startsWith("0") && value.length > 1) value = value.slice(1);
                                setInventory({...inventory,
                                    content: [...inventory.content.slice(0, itemIndex), 
                                    {
                                        ...inventory.content[itemIndex], 
                                        value: value
                                    },
                                    ...inventory.content.slice(itemIndex + 1)]
                                });
                            }}
                            onChange = {e => {
                                setInventory({...inventory,
                                    content: [...inventory.content.slice(0, itemIndex), 
                                    {
                                        ...inventory.content[itemIndex], 
                                        value: e.currentTarget.value
                                    },
                                    ...inventory.content.slice(itemIndex + 1)]
                                });
                            }}
                        />
                        <span className = {"font-weight-bold " + (inventory.content[itemIndex].qty < window.parseInt(inventory.content[itemIndex].value || inventory.content[itemIndex].qty)?"text-success": "text-danger")}>
                            {inventory.content[itemIndex].qty === window.parseInt(inventory.content[itemIndex].value || inventory.content[itemIndex].qty)?
                                ""
                                :
                                (
                                    inventory.content[itemIndex].qty < window.parseInt(inventory.content[itemIndex].value || inventory.content[itemIndex].qty)?
                                    "+" + (window.parseInt(inventory.content[itemIndex].value || inventory.content[itemIndex].qty) - inventory.content[itemIndex].qty)
                                    :
                                    window.parseInt(inventory.content[itemIndex].value || inventory.content[itemIndex].qty) - inventory.content[itemIndex].qty
                                )
                            }
                        </span>
                    </li>)}
                    <details>
                        <summary className = "h5 text-success">Extra List</summary>
                        {inventory.content.slice(base).map((item, itemIndex) =>
                        <li key = {itemIndex + base} className = "mb-2">
                            <label className = "mr-2 inline" htmlFor = {"inventory item " + (itemIndex + base)}>
                                <span>{item.title}</span>
                                <span className = "ml-2 text-info">{item.qty}</span>
                            </label>
                            <input
                                type = "number"
                                step = {1}
                                //max = {item.qty}
                                min = {0}
                                style = {{maxWidth: 100}}
                                className = "form-control inline mr-2"
                                id = {"inventory item " + (itemIndex + base)}
                                value = {inventory.content[itemIndex + base].value || ""}
                                onKeyDown = {(e) => ['e','.'].includes(e.key) && e.preventDefault()}
                                onBlur = {e => {
                                    let value = e.currentTarget.value;
                                    while(value.startsWith("0") && value.length > 1) value = value.slice(1);
                                    setInventory({...inventory,
                                        content: [...inventory.content.slice(0, itemIndex + base), 
                                        {
                                            ...inventory.content[itemIndex + base], 
                                            value: value
                                        },
                                        ...inventory.content.slice(itemIndex + base + 1)]
                                    });
                                }}
                                onChange = {e => {
                                    setInventory({...inventory,
                                        content: [...inventory.content.slice(0, itemIndex + base), 
                                        {
                                            ...inventory.content[itemIndex + base], 
                                            value: e.currentTarget.value
                                        },
                                        ...inventory.content.slice(itemIndex + base + 1)]
                                    });
                                }}
                            />
                            <span className = {"font-weight-bold " + (inventory.content[itemIndex + base].qty < window.parseInt(inventory.content[itemIndex + base].value || inventory.content[itemIndex + base].qty)?"text-success": "text-danger")}>
                                {inventory.content[itemIndex + base].qty === window.parseInt(inventory.content[itemIndex + base].value || inventory.content[itemIndex + base].qty)?
                                    ""
                                    :
                                    (
                                        inventory.content[itemIndex + base].qty < window.parseInt(inventory.content[itemIndex + base].value || inventory.content[itemIndex + base].qty)?
                                        "+" + (window.parseInt(inventory.content[itemIndex + base].value || inventory.content[itemIndex + base].qty) - inventory.content[itemIndex + base].qty)
                                        :
                                        window.parseInt(inventory.content[itemIndex + base].value || inventory.content[itemIndex + base].qty) - inventory.content[itemIndex + base].qty
                                    )
                                }
                            </span>
                        </li>)}
                    </details>
                </div>
                :null}
                {curTruckNumber?
                <div>
                    <div className = "h4 mt-3 mb-2">Inspection Criteria:</div>
                    {list.map((item, itemIndex) =>
                    <li key = {itemIndex} className = "mb-2">
                        <label className = "mr-2 inline" htmlFor = {"item " + itemIndex}>{item}</label>
                        <input
                            type = "checkbox"
                            style = {{
                                minWidth: 28, minHeight: 28, 
                                verticalAlign: "middle"
                            }}
                            id = {"item " + itemIndex}
                            checked = {inventory.checkList[itemIndex]}
                            onChange = {e => {
                                const checked = e.currentTarget.checked;
                                setInventory(inventory => ({...inventory,
                                    checkList: [
                                        ...inventory.checkList.slice(0, itemIndex), 
                                        checked,
                                        ...inventory.checkList.slice(itemIndex + 1)
                                    ]
                                }));
                            }}
                        />
                    </li>)}
                </div>
                :null}
            </div>
            </>:null}
            <div className = "blk5 mb-2" style = {{display: "flex"}}>
                <label className = "required-field mr-3">Member name:</label>
                <input
                    type = "text" 
                    className = "form-control mr-3" 
                    readOnly
                    name = "memberName"
                    value = {userName || user.userName} 
                />
                <label className = "required-field mr-3">Date:</label>
                <input
                    type = "text"
                    className = "form-control mr-3 w-100"
                    readOnly
                    name = "submitDate" 
                    value = {(new MyDate()).s()}
                />
            </div>
        </Modal>
    )    
}